import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from 'reducers';
import apiMiddleware from 'middlewares/api-middleware';
import mapboxMiddleware from 'middlewares/mapbox-middleware';

// Creates a preconfigured store for this example.
export default function configureStore(defaultState) {
  const middlewares = [thunk, apiMiddleware, mapboxMiddleware];
  if (process.env.NODE_ENV === 'development') {
    /* eslint-disable global-require */
    // Only want to require it when in development mode.
    const createLogger = require('redux-logger');

    const logger = createLogger({
      level: 'info',
      collapsed: true,
      duration: true,
    });
    middlewares.push(logger);
  }

  return createStore(rootReducer, defaultState, applyMiddleware(...middlewares));
}



/** WEBPACK FOOTER **
 ** ./src/js/stores/configure-store.js
 **/